<template>
  <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill="currentColor" d="M0.999998 0C0.734781 0 0.480427 0.105357 0.292891 0.292893C0.105354 0.48043 -1.90735e-06 0.734784 -1.90735e-06 1V8H2V2H18V16H12V18H19C19.2652 18 19.5196 17.8946 19.7071 17.7071C19.8946 17.5196 20 17.2652 20 17V1C20 0.734784 19.8946 0.48043 19.7071 0.292893C19.5196 0.105357 19.2652 0 19 0H0.999998ZM0.999998 10C0.734781 10 0.480427 10.1054 0.292891 10.2929C0.105354 10.4804 -1.90735e-06 10.7348 -1.90735e-06 11V17C-1.90735e-06 17.2652 0.105354 17.5196 0.292891 17.7071C0.480427 17.8946 0.734781 18 0.999998 18H9C9.26521 18 9.51957 17.8946 9.70711 17.7071C9.89464 17.5196 10 17.2652 10 17V11C10 10.7348 9.89464 10.4804 9.70711 10.2929C9.51957 10.1054 9.26521 10 9 10H0.999998ZM2 12H8V16H2V12ZM10.5 4L12.543 6.043L10.293 8.293L11.707 9.707L13.957 7.457L16 9.5V4H10.5Z" />
  </svg>
</template>

<script>
export default {
  name: "Maximixar"
}
</script>

<style scoped>

</style>
